export default {
  title: 'Tärkeät huomautukset',
  buttons: {
    add_note: 'Lisää huomautus',
  },
};
